import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { APP_NAME } from './brand'
import { bscTestnet, arcTestnet } from './chains'
import {
  metaMaskWallet,
  okxWallet,
  walletConnectWallet,
  coinbaseWallet,
  trustWallet,
  injectedWallet,
} from '@rainbow-me/rainbowkit/wallets'

export const wagmiConfig = getDefaultConfig({
  appName: APP_NAME,
  projectId: 'axonswap-dev-local', // WalletConnect project ID — replace for production
  chains: [bscTestnet, arcTestnet],
  wallets: [
    {
      groupName: 'Popular',
      wallets: [
        metaMaskWallet,
        okxWallet,
        walletConnectWallet,
        coinbaseWallet,
        trustWallet,
        injectedWallet,
      ],
    },
  ],
  ssr: false,
})
